module.exports = __webpack_public_path__ + "media/images/shopping/complete/eyecatch-staff-01-dfa3d9ae2bf693f41a3cc121b33acd57.svg";